
import { defineAsyncComponent, defineComponent } from "vue";
import WishBanners from "@/components/WishBanners/WishBanners.vue";
import FatePurchaseDialog from "@/components/overlays/FatePurchaseDialog.vue";
import ItemRevealScreen from "@/components/ScreenItemReveal/ItemRevealScreen.vue";
import ItemAllRevealScreen from "@/components/ScreenItemReveal/ItemAllRevealScreen.vue";
import ItemObtainOverlay from "@/components/overlays/ItemObtainOverlay.vue";
import QuestScreen from "@/components/ScreenQuest/QuestScreen.vue";
import ShopScreen from "@/components/ScreenShop/ShopScreen.vue";
import Gacha from "@/state/Gacha";
import { Banner, Item, ItemStringQuantity } from "@/types";
import Inventory from "@/state/Inventory";
import GameMenu from "@/components/game/GameMenu.vue";

// empty comment below is to maintain multi-line array
// to keep prettier happy (do not remove)
const BANNERS = [
  "moment-of-bloom-2", //
  "drifting-luminescence-2",
  "the-transcendent-one-returns",
  "wanderlust-invocation",
  "everything",
];

export default defineComponent({
  components: {
    WishBanners,
    FatePurchaseDialog,
    VideoPlayer: defineAsyncComponent(
      () => import("@/components/ScreenVideo/VideoPlayer.vue")
    ),
    ItemRevealScreen,
    ItemAllRevealScreen,
    ItemObtainOverlay,
    QuestScreen,
    ShopScreen,
    GameMenu,
  },
  data() {
    return {
      // storage vars
      gachas: BANNERS.map(
        (id) =>
          new Gacha(
            require(`@/custom/banners/${id}.json`), // eslint-disable-line
            undefined,
            this.$store.state.settings
          )
      ),
      // state vars
      checkPullDialog: false,
      pullNumber: 1,
      pullRarity: 0,
      useStandardFates: false,
      screen: "wish-banner",
      lastRoll: [] as Item[],
      lastRollSorted: [] as Item[],
      banners: BANNERS.map((id) =>
        require(`@/custom/banners/${id}.json`)
      ) as Banner[],
      currentBannerIndex: 0,
      overlay: "",
      pullExtraRewards: [] as ItemStringQuantity[],
      detailedPullExtraRewards: [] as ItemStringQuantity[],
    };
  },
  computed: {
    standardGacha(): Gacha {
      return this.gachas[this.currentBannerIndex];
    },
    currentBanner(): Banner {
      return this.banners[this.currentBannerIndex];
    },
    fatesToPurchase(): number {
      return (
        this.pullNumber -
        (this.useStandardFates ? this.inv.standardFates : this.inv.fates)
      );
    },
    inv(): Inventory {
      return this.$store.state.inventory;
    },
  },
  mounted() {
    const bgm: HTMLAudioElement = this.$refs.audioBgm as HTMLAudioElement;
    bgm.volume = 0.1;
  },
  methods: {
    changeBannerIndex(index: number): void {
      this.currentBannerIndex = index;
    },
    wish(pulls: number, useStandardFates: boolean): void {
      this.useStandardFates = useStandardFates;
      this.pullNumber = pulls;
      if (
        this.$store.state.settings.infinitePrimos ||
        pulls <=
          (this.useStandardFates ? this.inv.standardFates : this.inv.fates)
      ) {
        this.goWish();
      } else {
        this.checkPullDialog = true;
      }
    },

    goWish(): void {
      // TODO: seriously consider moving wish and video logic
      // to WishBanners so that gachas are linked together
      if (!this.$store.state.settings.infinitePrimos) {
        if (this.useStandardFates) {
          this.inv.standardFates -= this.pullNumber;
        } else {
          this.inv.fates -= this.pullNumber;
        }
      }
      this.checkPullDialog = false;
      this.screen = "video-player";

      this.lastRoll =
        this.pullNumber === 1
          ? [this.standardGacha.rollOne(this.$store.state.settings.rollOnly)]
          : this.standardGacha.rollTen(this.$store.state.settings.rollOnly);
      this.lastRollSorted = [...this.lastRoll];
      this.lastRollSorted.sort((a, b) => b.rarity - a.rarity); // highest rarity to lowest

      console.log(
        "Banner",
        this.currentBanner.id,
        "rolled:",
        [...this.lastRoll.map((i) => Object.assign({}, i))] // thank you vue love that
      );
      this.pullRarity = this.lastRollSorted[0].rarity;
      const extraRewards = this.inv.addItemsViaGacha(
        this.lastRoll,
        this.currentBanner.storage,
        this.currentBanner.description
      );
      this.pullExtraRewards = [
        {
          // TODO: these reduces are failing because arrays are empty, probably shortcircuit/return 0
          id: "stardust",
          quantity: extraRewards
            .filter((i) => i.id === "stardust")
            ?.reduce(
              (a, b) => {
                return { id: "", quantity: a.quantity + b.quantity };
              },
              { quantity: 0 }
            ).quantity,
        },
        {
          id: "starglitter",
          quantity: extraRewards
            .filter((i) => i.id === "starglitter")
            ?.reduce(
              (a, b) => {
                return { id: "", quantity: a.quantity + b.quantity };
              },
              { quantity: 0 }
            ).quantity,
        },
      ];
      this.detailedPullExtraRewards = extraRewards;
    },

    cancelWish(): void {
      this.checkPullDialog = false;
    },

    // hacky :/ but the audio element is unfortunately unmounted
    // before the audio fully plays
    exitConfirmCancelDialog(fn: () => void, fatesNeeded?: number): void {
      (this.$refs.audioExitDialog as HTMLAudioElement).play();
      if (fatesNeeded) {
        this.inv.primos -= fatesNeeded * 160;
        if (this.useStandardFates) {
          this.inv.standardFates += fatesNeeded;
        } else {
          this.inv.fates += fatesNeeded;
        }
      }
      fn();
    },

    showResults(): void {
      this.screen = "item-reveal";
    },

    showResultsEnd(): void {
      this.screen = "item-reveal";
      // TODO: yikes you have to check if it's 10 or not since i
      // think they have different uis
    },
  },
});
